<div class="row" *ngIf="authProvider == 1" style="padding: 5px; width: 99%;" >
  <div class="col-md-10" *ngIf="isLoggedInAD() ; else loggedOutAD">
    <app-topbar [secLevel]='secLevel'></app-topbar>
  </div>

  <ng-template #loggedOutAD>
    <div class="col-md-10">
      &nbsp;
    </div>
  </ng-template>

  <div class="col-md-2" style="text-align: right;">
    <app-auth-button></app-auth-button>
  </div>

</div>


<div class='container-fluid' style="padding-top: 10px; padding-bottom: 10px;" >
    <router-outlet></router-outlet>
</div>
